import React from "react";
import styles from "./style.module.css";
import moment from "moment";

import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem, TileButton, Icon } from "aible";

import CreateTile from "components/Tiles/CreateTile";

import ImportAppIcon from "images/import_app.svg";
import CreateAppIcon from "images/circle-plus-light-purple.svg";
import FlaskIcon from "images/az_images/flask.svg";
import FlaskCircleIcon from "images/az_images/flask-circle.svg";

import ShareChatApp from "components/ChatApp/ShareChatApp";
import TestChatApp from "components/ChatApp/TestChatApp";

import SandboxTiles from "components/Openshell/SandboxTiles";

import { openUri } from "containers/Help/reducer";

import { isEnabled } from "utils/featureFlags";
import TemplatesView from "components/View/TemplatesView";
import { VIEW_TYPE } from "containers/View/reducer";

export default class ChatAppView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shareChatAppId: undefined,
      showShareModal: false
    };
  }

  render() {
    const { chatApps, updateViewType, history, searchText } = this.props;
    const { shareChatAppId, showShareModal, showTestModal, testModalId } = this.state;

    const apps = [];
    /*[
      {
        title: "Email Automation",
        description: "Automatically generate follow-up sales emails",
        type: "EMAIL"
      },
      {
        title: "Order Fulfillment Agent",
        description: "Helping expedite furniture orders for our customers.",
        type: "CUSTOM",
        onClick: () => {
          const AIBLE_ANYWHERE_DEMO_LINK = "https://aible-anywhere.andanipa.com/demo/compound/index.html";
          openUri(AIBLE_ANYWHERE_DEMO_LINK);
        }
      },
    ];
    */

    const azChatApps = chatApps ? chatApps.filter((app) => app?.wizard?.isAZTestApp === true) : [];
    const retChatApps =
      searchText?.length > 0
        ? azChatApps.filter((app) => app?.name?.toLowerCase().includes(searchText.toLowerCase()))
        : azChatApps;
    return (
      <div className={styles.chatAppView}>
        <ShareChatApp
          id={shareChatAppId}
          showModal={showShareModal}
          updateShowModal={(val) => {
            this.setState({
              shareChatAppId: undefined,
              showShareModal: false
            });
          }}
          hideButton
        >
          {"Share Chat App"}
        </ShareChatApp>
        <TestChatApp
          showModal={showTestModal}
          id={testModalId}
          updateShowModal={(val) => this.setState({ showTestModal: val })}
        />
        {!isEnabled("spark-agents-templates-view") && (
          <div className={styles.agentAZTesting}>
            <div className={styles.agentAZHeader}>
              <div>{"Agent A/Z Testing"}</div>
              <Button
                style={{ marginLeft: "40px" }}
                onClick={() => {
                  this.setState({ showTestModal: true, testModalId: null });
                }}
              >
                {"Create Agent Test"}
              </Button>
              <Button style={{ marginLeft: "20px" }} onClick={() => updateViewType(VIEW_TYPE.MONITORING)}>
                {"View Results"}
              </Button>
            </div>
            <div className={styles.chatAppTiles}>
              {/* {isEnabled("chat-app-create-import") && this.renderCreateAppTile()} */}
              {isEnabled("chat-app-create-import") && this.renderImportAppTile()}
              {apps &&
                apps.map((app, i) => {
                  if (app?.type === "EMAIL" && isEnabled("chat-aible-email-generation")) {
                    return this.renderEmailTile(app);
                  }
                  if (app?.type === "TEST" && isEnabled("az-testing")) {
                    return this.renderTestTile(app);
                  }
                  if (app?.type === "CUSTOM") {
                    return this.renderEmailTile(app);
                  }

                  return <React.Fragment key={i} />;
                })}
              {retChatApps.length === 0 ? (
                <div className={styles.notFoundMessage}>{"No Agent A/Z tests found"}</div>
              ) : (
                retChatApps.toReversed().map((app) => this.renderChatAppTile(app))
              )}
            </div>
          </div>
        )}

        {isEnabled("openshell") && (
          <div className={styles.agentAZTesting}>
            <div className={styles.agentAZHeader}>
              <div>{"NVIDIA OpenShell Agents"}</div>
            </div>
            <SandboxTiles />
          </div>
        )}
        <TemplatesView forceTabView={"SAVED_WORK"} history={history} />
      </div>
    );
  }

  renderChatAppTile(app) {
    const { initChatApp, handleDelete, chatApps } = this.props;

    let additionalOptions = undefined;
    let retDescription = app?.wizard?.description;
    const isAZTestApp = app?.wizard?.isAZTestApp;
    if (isAZTestApp) {
      additionalOptions = [
        {
          label: "Update A to Z Test",
          onClick: () => this.setState({ showTestModal: true, testModalId: app.id })
        }
      ];
      const azTests = app?.wizard?.azTests;
      const currTest = azTests[azTests.length - 1];
      const dateStart = currTest?.dateStart;
      const testApps = currTest?.testApps;
      const appData = testApps
        .map((aId) => {
          const tApp = chatApps.find((a) => a?.id === aId);
          const distribution = currTest.appDistribution[aId];
          if (tApp && distribution) {
            return {
              label: tApp.name,
              value: aId,
              distribution: distribution
            };
          }
        })
        .filter((a) => a);
      if (currTest) {
        const testApps = (
          <React.Fragment>
            <TileItem icon={"target"}>{"A/Z Test"}</TileItem>
            {appData?.map((aData, i) => {
              return (
                <TileItem key={"azTest" + aData.label + i}>
                  <span>{`${aData.label}: `}</span>
                  <strong>{`${aData.distribution}%`}</strong>
                </TileItem>
              );
            })}
            <TileItem icon={"calendar"}>{moment.utc(dateStart).local().fromNow()}</TileItem>
          </React.Fragment>
        );

        retDescription = testApps;
      }
    }

    /*
    return (
      <Tile
        onClick={() => initChatApp(app)}
        handleDelete={!isNaN(Number(app?.id)) ? () => handleDelete(app?.id) : undefined}
        buttonText={"Open App"}
        onClickSecond={(e) => {
          e.stopPropagation();
          this.setState({
            shareChatAppId: app?.id,
            showShareModal: true,
          })
        }}
        secondButton={"Share App"}
        additionalOptions={additionalOptions}
        key={"chatapp_" + app?.id}
      >
        <TileTitle
          title={app?.name}
          icon={isAZTestApp ? <Icon src={FlaskIcon} size={20} /> : "deployment"}
          // icon={"deployment"}
          color={"deployment"}>
          {app?.name}
        </TileTitle>
        <TileBody isLoading={false}>
          <div>{retDescription}</div>
        </TileBody>
      </Tile>
    );
    */

    return (
      <div className={styles.azTile} onClick={() => initChatApp(app)}>
        <div className={styles.azActions}>
          <Button
            className={styles.azButton}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ showTestModal: true, testModalId: app.id });
            }}
          >
            {"Update A to Z Test"}
          </Button>
          <Button
            className={styles.azButton}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({
                shareChatAppId: app?.id,
                showShareModal: true
              });
            }}
          >
            {"Share Agent"}
          </Button>
          <Button className={styles.azButton} onClick={() => initChatApp(app)}>
            {"Open Agent"}
          </Button>
          <Button
            className={styles.azButton}
            onClick={(e) => {
              e.stopPropagation();
              if (!isNaN(Number(app?.id))) {
                handleDelete(app?.id);
              }
            }}
          >
            {"Delete"}
          </Button>
        </div>
        <div className={styles.azIcon}>
          <Icon src={FlaskIcon} size={38} />
        </div>
        <div className={styles.azContent}>
          <div className={styles.azTopLabel}>{app?.name}</div>
          <div>{(app?.wizard?.azTests ?? []).length + " agents in test"}</div>
          <div>{moment.utc(app?.created_date).local().fromNow()}</div>
        </div>
      </div>
    );
  }

  renderTestTile(app) {
    const { showTestModal } = this.state;

    return (
      <Tile
        key={"testapp_" + app?.id}
        isTileClick
        onClick={() => {
          this.setState({ showTestModal: true, testModalId: null });
        }}
        buttonText={app?.title}
        showButton={true}
      >
        <TileBody isLoading={false}>
          <div className={styles.createTileIconWrapper}>
            <div className={styles.createTileIcon}>
              <img src={FlaskCircleIcon} alt={app?.title} />
            </div>
          </div>
        </TileBody>
      </Tile>
    );
  }

  renderEmailTile(app) {
    const { initEmailApp } = this.props;

    return (
      <Tile
        onClick={() => {
          if (app?.type === "CUSTOM") {
            return app?.onClick();
          }
          initEmailApp();
        }}
        isTileClick
        key={"emailapp_" + app?.id}
      >
        <TileTitle title={app?.title} icon={"deployment"} color={"deployment"}>
          {app?.title}
        </TileTitle>
        <TileBody isLoading={false}>
          <div>{app?.description}</div>
        </TileBody>
      </Tile>
    );
  }

  renderCreateAppTile() {
    const { initCreateApp } = this.props;

    return (
      <CreateTile
        onClick={() => initCreateApp()}
        buttonText={"Create App"}
        loadingText={"Create App"}
        icon={CreateAppIcon}
      />
    );
  }

  renderImportAppTile() {
    const { initImportApp } = this.props;

    return (
      <CreateTile
        onClick={() => initImportApp()}
        buttonText={"Import App"}
        loadingText={"Import App"}
        icon={ImportAppIcon}
      />
    );
  }
}
